export default __webpack_public_path__ + "static/media/c5.071e6a2a.jpg";